// extracted by mini-css-extract-plugin
export var videoHero = "_b2-4";
export var videoHeroImage = "_b2-5";
export var videoHeroOverlay = "_b2-6";
export var videoHeroSubtitle = "_b2-8";
export var videoHeroText = "_b2-7";
export var videoLauncher = "_b2-0";
export var videoLauncherIcon = "_b2-1";
export var videoLauncherSubtitle = "_b2-3";
export var videoLauncherTitle = "_b2-2";
export var videoPlayer = "_b2-a";
export var videoPlayerWrap = "_b2-9";